<template>
    <div class="flex h-full items-center justify-end ">
        <div v-if="showDeleteConfirmation" class="flex items-center gap-x-1">
            <UButton
                size="xs"
                data-cy="confirm-delete-invoice"
                color="error"
                @click.stop="handleDelete"
            >
                Slett?
            </UButton>
            <UButton
                size="xs"
                variant="ghost"
                icon="i-ph-x"
                @click.stop="showDeleteConfirmation = false"
            />
        </div>
        <div v-else class="flex items-center gap-1">
            <UButton
                title="Hent kladd"
                size="xs"
                variant="ghost"
                class="text-lg hover:text-primary"
                :icon="isSelected ? 'i-ph-eye-fill' : 'i-ph-eye'"
                data-cy="update-draft-button"
                @click.stop="handleRetrieve"
            />
            <UButton
                title="Slett kladd"
                size="xs"
                variant="ghost"
                color="neutral"
                icon="i-ph-trash-fill"
                data-cy="delete-draft-button"
                @click.stop="showDeleteConfirmation = true"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, Ref, ref} from 'vue'

const props = defineProps({
    params: {
        type: Object as () => {
            deleteSingleDraft: () => Promise<any>,
            selectDraft: () => void,
            context: {
                invoiceDraftUuid: Ref<string>
            },
            data: {
                uuid: string
            }
        },
        required: true
    }
})

const uuid = computed(() => props.params?.data.uuid)
const draftUuid = computed(() => props.params?.context.invoiceDraftUuid.value)
const isSelected = computed(() => uuid.value === draftUuid.value)

const showDeleteConfirmation = ref(false)

const handleDelete = async () => await props.params.deleteSingleDraft()

const handleRetrieve = () => props.params.selectDraft()

</script>

<style scoped>

</style>